import { render, staticRenderFns } from "./MisMateriasnew.vue?vue&type=template&id=ff1b7e7a&scoped=true"
import script from "./MisMateriasnew.vue?vue&type=script&lang=js"
export * from "./MisMateriasnew.vue?vue&type=script&lang=js"
import style0 from "./MisMateriasnew.vue?vue&type=style&index=0&id=ff1b7e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1b7e7a",
  null
  
)

export default component.exports